import { render, staticRenderFns } from "./DecisionListForm.vue?vue&type=template&id=78aa8528&"
import script from "./DecisionListForm.vue?vue&type=script&lang=js&"
export * from "./DecisionListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports